import { useState, useEffect } from "react";
import { List } from "lucide-react";

export default function TableOfContents({ items }) {
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: "0px 0px -60% 0px" }
    );

    items.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [items]);

  return (
    <nav className="bg-secondary/50 border border-border rounded-xl p-5 mb-8">
      <div className="flex items-center gap-2 mb-3">
        <List className="w-4 h-4 text-accent" />
        <span className="text-sm font-heading font-semibold uppercase tracking-wider">Table of Contents</span>
      </div>
      <ol className="space-y-1.5">
        {items.map((item, i) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`text-sm transition-colors hover:text-accent flex gap-2 ${
                activeId === item.id ? "text-accent font-medium" : "text-muted-foreground"
              } ${item.indent ? "ml-4" : ""}`}
            >
              <span className="font-mono text-xs text-muted-foreground/50 mt-0.5 shrink-0">{i + 1}.</span>
              {item.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}